/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Description, Input, Label } from "@nordcloud/gnui";
import { Fieldset } from "~/components/Forms";

function mapInputStatus(
  input: "error" | "success" | undefined
): "danger" | "success" | undefined {
  return input === "error" ? "danger" : input;
}

type InputFieldProps = {
  label: string;
  name: string;
  error?: "error" | "success";
  type?: string;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  status?: string;
  disabled?: boolean;
  required?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const InputField = React.forwardRef(
  (
    {
      label,
      name,
      value,
      defaultValue,
      error,
      type = "text",
      disabled,
      required,
      onChange,
      placeholder,
    }: InputFieldProps,
    ref: React.Ref<HTMLInputElement>
  ) => (
    <Fieldset>
      <Label name={label} required={required} />
      <Input
        type={type}
        name={name}
        defaultValue={defaultValue}
        status={mapInputStatus(error)}
        value={value}
        placeholder={placeholder || label}
        ref={ref}
        disabled={disabled}
        onChange={onChange}
      />
      {error && <Description>{label} is required.</Description>}
    </Fieldset>
  )
);

export default InputField;
